import React from 'react';
import BannerSectionStyle5 from '../Section/BannerSection/BannerSectionStyle5';
import ContactForm from '../ContactForm';
import Section from '../Section';
import ContactInfoSection from '../Section/ContactInfoSection';
import { pageTitle } from '../../helpers/PageTitle';
import { BASE_URL } from "../../helpers/api";


export default function Contact() {
  pageTitle('Contact');
  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/contact/banner_bg.svg"
        imgUrl="/images/telephone1.png"
        title="Contact Us"
        subTitle="Reach out to us for the fastest response and care"
      />
      <div className="container cs_mt_minus_110">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <ContactForm />
          </div>
        </div>
      </div>
      <Section
        topMd={60}
        topLg={50}
        topXl={70}
        bottomMd={60}
        bottomLg={50}
        bottomXl={10}
      >
        { <ContactInfoSection sectionTitle="Find Us Here" /> }
      </Section>
    </>
  );
}
